// eslint-disable-next-line import/prefer-default-export
export const REQUEST_SUBMIT_FEEDBACK = 'feedback/REQUEST_SUBMIT_FEEDBACK';
